__turbopack_context__.v({
  "checkbox": "TestFeatureFlagsModal-module-scss-module__rqW2eG__checkbox",
  "closeButton": "TestFeatureFlagsModal-module-scss-module__rqW2eG__closeButton",
  "flagContent": "TestFeatureFlagsModal-module-scss-module__rqW2eG__flagContent",
  "flagDescription": "TestFeatureFlagsModal-module-scss-module__rqW2eG__flagDescription",
  "flagItem": "TestFeatureFlagsModal-module-scss-module__rqW2eG__flagItem",
  "flagLabel": "TestFeatureFlagsModal-module-scss-module__rqW2eG__flagLabel",
  "flagsList": "TestFeatureFlagsModal-module-scss-module__rqW2eG__flagsList",
});
